import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DemoSection from './components/DemoSection';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import ExampleAds from './components/ExampleAds';
import Testimonials from './components/Testimonials';
import PricingPreview from './components/PricingPreview';
import CTABanner from './components/CTABanner';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <Hero />
        <DemoSection />
        <Features />
        <HowItWorks />
        <ExampleAds />
        <Testimonials />
        <PricingPreview />
        <CTABanner />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
